import { render, staticRenderFns } from "./TabPerfilAcesso.vue?vue&type=template&id=819c6712&"
import script from "./TabPerfilAcesso.vue?vue&type=script&lang=js&"
export * from "./TabPerfilAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports